<template src='./VehicleCategoryForm.html'></template>
<script>
import { MESSAGES } from "@/utils/constants";
import Vue from "vue";
import { notify } from "@/utils/notification-helper";
export default {
  data: function() {
    return {
      add: this.$route.params.add,
      categoryData: {},
      VehicleList: [
        { name: "type 1", id: 1 },
        { name: "type 2", id: 2 }
      ],
      gridData: [
        { Type: "Price", Price: "", inEdit: true },
        { Type: "Escort Price", Price: "", inEdit: true },
        { Type: "Special Price", Price: "", inEdit: true },
        { Type: "Escort Special Price", Price: "", inEdit: true },
        { Type: "Conversation Price", Price: "", inEdit: true }
      ],
      columns: [
        { field: "Type", title: "Type", editable: false },
        { field: "Price", title: "Price" }
      ]
    };
  },
  methods: {
    goToListPage: function() {
      this.$router.push({ name: "vehicle-category" });
    },

    handleChange(event) {
      this.gender = event.value.val;
    },
    handleChangeVendor(event) {
      this.vendorName = event.value.id;
    },
    addCategory: function() {
     
      this.categoryData.vehicleType = this.categoryData.vehicleType.name;
      this.categoryData.price = this.gridData[0].Price;
      this.categoryData.escortPrice = this.gridData[1].Price;
      this.categoryData.specialPrice = this.gridData[2].Price;
      this.categoryData.escortSpecialPrice = this.gridData[3].Price;
      this.categoryData.conversationPrice = this.gridData[4].Price;
     
      if (this.add) {
        this.$store
          .dispatch("vehicleCategory/addCategory", this.categoryData)
          .then(() => {
            notify(MESSAGES.CHANGES_SAVE_SUCCESS);
          });
      } else {
        this.$store
          .dispatch("vehicleCategory/updateCategory", this.categoryData)
          .then(() => {
            notify(MESSAGES.CHANGES_SAVE_SUCCESS);
          });
      }

      // this.goToListPage();
    },

    itemChange: function(e) {
      const data = this.gridData.slice();
      const index = data.findIndex(d => d.Type === e.dataItem.Type);
      data[index] = { ...data[index], [e.field]: e.value };
      this.gridData = data;
      Vue.set(e.dataItem, e.field, e.value);
    },
    async getDataOnload() {
      await this.$store.dispatch("loadVendors", null, { root: true });
    }
  },
  computed: {},
  beforeMount() {
    this.categoryData = this.$store.getters["vehicleCategory/vehicle"];
    if (this.categoryData != {}) {
      // console.log(this.categoryData);
      this.gridData[0].Price = this.categoryData.price;
      this.gridData[1].Price = this.categoryData.escortPrice;
      this.gridData[2].Price = this.categoryData.specialPrice;
      this.gridData[3].Price = this.categoryData.escortSpecialPrice;
      this.gridData[4].Price = this.categoryData.conversationPrice;
      this.categoryData.vehicleType = this.VehicleList.find(
        obj => obj.name == this.categoryData.vehicleType
      );
      this.getDataOnload();
    }
  }
};
</script>
<style scoped>
</style>